"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = flattenDeepPropertyList;

var _browser = _interopRequireDefault(require("../../../constants/browser"));

// constants

/**
 * Deeptly iterate over an object to get a list of paths associated to a value.
 * @example
 * flattenDeepPropertyList({
 *   foo: {
 *     bar: ["quuz", "quux"],
 *     corge: "garply"
 *   },
 *   barfoo: Infinity,
 * });
 * // [
 * //   [["foo", "bar", "0"], "quuz"],
 * //   [["foo", "bar", "1"], "quux"],
 * //   [["foo", "corge"], "garply"],
 * //   [["barfoo"], Infinity],
 * // ]
 */
function flattenDeepPropertyList(data, path = [], preserveEmptyObjects = false) {
  return Object.keys(data).reduce((keyListAcc, key) => {
    if ("object" === typeof data[key] && null !== data[key] && (!_browser.default || !(data[key] instanceof File) && !(data[key] instanceof Blob))) {
      if (("[object Object]" === Object.prototype.toString.call(data[key]) || Array.isArray(data[key])) && 0 === Object.keys(data[key]).length && preserveEmptyObjects) {
        keyListAcc.push([[...path, key], data[key]]);
      } else {
        keyListAcc.push(...flattenDeepPropertyList(data[key], [...path, key], preserveEmptyObjects));
      }
    } else {
      keyListAcc.push([[...path, key], data[key]]);
    }

    return keyListAcc;
  }, []);
}